
// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Menu,
//   MenuItem
// } from '@mui/material';
// import DownloadIcon from '@mui/icons-material/Download';
// import LogoutIcon from '@mui/icons-material/Logout';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import { useNavigate } from 'react-router-dom';
// import './AdminPaymentTable.css';

// const dummyData = Array.from({ length: 10 }).map((_, index) => ({
//   registrationNo: `REG00${index + 1}`,
//   name: `User ${index + 1}`,
//   projectType: index % 2 === 0 ? 'Mining' : 'Non Mining',
//   subCategory: index % 2 === 0 ? 'Upto 2 hectares' : 'Above Rs.5 Crores to Rs.25 Crores',
//   mobile: `98765432${10 + index}`,
//   email: `user${index + 1}@example.com`,
//   amount: index % 2 === 0 ? '10000' : '180000',
//   method: index % 2 === 0 ? 'Online' : 'Cash',
//   date: '2025-06-20',
//   time: '12:34 PM'
// }));

// const AdminPaymentTable = () => {
//   const [data] = useState(dummyData);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const navigate = useNavigate();

//   const exportExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
//     XLSX.writeFile(workbook, "admin_payment_records.xlsx");
//   };

//   const exportCSV = () => {
//     const worksheet = XLSX.utils.json_to_sheet(data);
//     const csv = XLSX.utils.sheet_to_csv(worksheet);
//     const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute('download', 'admin_payment_records.csv');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const exportPDF = () => {
//     const doc = new jsPDF();
//     doc.text("Admin Payment Records", 14, 16);
//     doc.autoTable({
//       startY: 20,
//       head: [[
//         "Registration No", "Name", "Project Type", "Sub Category",
//         "Mobile", "Email", "Amount", "Method", "Date", "Time"
//       ]],
//       body: data.map(row => [
//         row.registrationNo,
//         row.name,
//         row.projectType,
//         row.subCategory,
//         row.mobile,
//         row.email,
//         row.amount,
//         row.method,
//         row.date,
//         row.time
//       ]),
//       styles: { fontSize: 8 }
//     });
//     doc.save('admin_payment_records.pdf');
//   };

//   const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = (format) => {
//     setAnchorEl(null);
//     if (format === 'csv') exportCSV();
//     if (format === 'excel') exportExcel();
//     if (format === 'pdf') exportPDF();
//   };

//   const handleLogout = () => {
//     navigate('/'); // Redirect to PaymentForm page
//   };

//   return (
//     <Box className="admin-payment-container">
//       <Box className="admin-table-header" display="flex" justifyContent="space-between" alignItems="center">
//         <Typography variant="h6" sx={{ fontWeight: 600 }}>Admin Payment Records</Typography>

//         <Box display="flex" gap={2}>
//           <Button
//             variant="contained"
//             startIcon={<DownloadIcon />}
//             onClick={handleMenuClick}
//             className="download-btn"
//           >
//             Download
//           </Button>

//           <Button
//             variant="outlined"
//             color="error"
//             startIcon={<LogoutIcon />}
//             onClick={handleLogout}
//           >
//             Logout
//           </Button>
//         </Box>

//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={() => setAnchorEl(null)}
//         >
//           <MenuItem onClick={() => handleMenuClose('csv')}>Download as CSV</MenuItem>
//           <MenuItem onClick={() => handleMenuClose('excel')}>Download as Excel</MenuItem>
//           <MenuItem onClick={() => handleMenuClose('pdf')}>Download as PDF</MenuItem>
//         </Menu>
//       </Box>

//       <TableContainer component={Paper}>
//         <Table className="admin-table">
//           <TableHead>
//             <TableRow>
//               {[
//                 "Registration No",
//                 "Proponent Name",
//                 "Project Type",
//                 "Sub Category",
//                 "Mobile Number",
//                 "Email",
//                 "Amount",
//                 "Payment Method",
//                 "Date",
//                 "Time"
//               ].map((head, i) => (
//                 <TableCell key={i} className="table-cell-head">{head}</TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {data.map((row, index) => (
//               <TableRow key={index}>
//                 <TableCell className="table-cell">{row.registrationNo}</TableCell>
//                 <TableCell className="table-cell">{row.name}</TableCell>
//                 <TableCell className="table-cell">{row.projectType}</TableCell>
//                 <TableCell className="table-cell">{row.subCategory}</TableCell>
//                 <TableCell className="table-cell">{row.mobile}</TableCell>
//                 <TableCell className="table-cell">{row.email}</TableCell>
//                 <TableCell className="table-cell">{row.amount}</TableCell>
//                 <TableCell className="table-cell">{row.method}</TableCell>
//                 <TableCell className="table-cell">{row.date}</TableCell>
//                 <TableCell className="table-cell">{row.time}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default AdminPaymentTable;






// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//     Box,
//     Typography,
//     Button,
//     TableContainer,
//     Table,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell,
//     Paper,
//     Menu,
//     MenuItem,
//     CircularProgress, // Added for loading indicator
//     Alert, // Added for error messages
//     TextField, // Added for search functionality
//     InputAdornment
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search'; // For the search icon
// import DownloadIcon from '@mui/icons-material/Download';
// import LogoutIcon from '@mui/icons-material/Logout';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import { useNavigate } from 'react-router-dom';
// import './AdminPaymentTable.css'; // Ensure this CSS file exists for styling

// // Removed dummyData as we will fetch real data

// const AdminPaymentTable = () => {
//     const [payments, setPayments] = useState([]); // State to hold fetched payments
//     const [loading, setLoading] = useState(true); // Loading state
//     const [error, setError] = useState(null); // Error state
//     const [searchTerm, setSearchTerm] = useState(''); // State for the search input
//     const [anchorEl, setAnchorEl] = useState(null); // For download menu

//     const navigate = useNavigate();

//     // Define your Firebase Function API URL
//     const apiURL = process.env.REACT_APP_API_URL || 'YOUR_FIREBASE_FUNCTION_URL';

//     // Helper function to convert Firestore Timestamp objects or ISO strings to locale string
//     const formatFirestoreTimestamp = (timestamp) => {
//         if (!timestamp) {
//             return 'N/A';
//         }
//         // If it's a Firestore Timestamp object with _seconds and _nanoseconds
//         if (typeof timestamp === 'object' && timestamp._seconds !== undefined) {
//             // Convert seconds to milliseconds
//             return new Date(timestamp._seconds * 1000).toLocaleString();
//         }
//         // If it's already an ISO string or a number (Unix milliseconds)
//         return new Date(timestamp).toLocaleString();
//     };


//     // useEffect to fetch data when the component mounts
//     useEffect(() => {
//         const fetchAllPayments = async () => {
//             try {
//                 setLoading(true);
//                 setError(null);
//                 const response = await axios.get(`${apiURL}/api/payments/all`);

//                 // Map and format timestamps from backend (which are ISO strings)
//                 const formattedPayments = response.data.payments.map(payment => ({
//                     ...payment,
//                     // Use the helper function to format timestamps
//                     timestamp: formatFirestoreTimestamp(payment.timestamp),
//                     updatedAt: formatFirestoreTimestamp(payment.updatedAt)
//                 }));
//                 setPayments(formattedPayments);
//             } catch (err) {
//                 console.error('Error fetching all payments:', err);
//                 setError('Failed to load payment records. Please ensure your backend is running and accessible.');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAllPayments();
//     }, [apiURL]); // Dependency array ensures it runs once on mount and if apiURL changes

//     // Filter payments based on search term (client-side filtering for simplicity)
//     const filteredPayments = payments.filter(payment =>
//         (payment.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.customer_phone?.includes(searchTerm) ||
//         payment.razorpay_order_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         (payment.razorpay_payment_id && payment.razorpay_payment_id.toLowerCase().includes(searchTerm.toLowerCase())) || // Check if payment_id exists
//         payment.status?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.project_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.sub_category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         payment.amount?.toString().includes(searchTerm))
//     );

//     // Export functions - now use the 'payments' state
//     const exportExcel = () => {
//         // Create a simplified data structure for export, focusing on relevant fields
//         const dataToExport = payments.map(p => ({
//             "Order ID": p.razorpay_order_id,
//             "Payment ID": p.razorpay_payment_id || 'N/A', // Keep Payment ID in exports
//             "Proponent Name": p.customer_name,
//             "Project Type": p.project_type,
//             "Sub Category": p.sub_category,
//             "Mobile Number": p.customer_phone,
//             "Email": p.customer_email,
//             "Amount (INR)": p.amount,
//             "Status": p.status,
//             "Initiated Date": p.timestamp, // Already formatted by formatFirestoreTimestamp
//             "Last Updated": p.updatedAt,   // Already formatted by formatFirestoreTimestamp
//             "Error Details": p.razorpay_error || 'N/A',
//             "Receipt URL": p.pdf_receipt_url || 'N/A'
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
//         XLSX.writeFile(workbook, "admin_payment_records.xlsx");
//     };

//     const exportCSV = () => {
//         const dataToExport = payments.map(p => ({
//             "Order ID": p.razorpay_order_id,
//             "Payment ID": p.razorpay_payment_id || 'N/A', // Keep Payment ID in exports
//             "Proponent Name": p.customer_name,
//             "Project Type": p.project_type,
//             "Sub Category": p.sub_category,
//             "Mobile Number": p.customer_phone,
//             "Email": p.customer_email,
//             "Amount (INR)": p.amount,
//             "Status": p.status,
//             "Initiated Date": p.timestamp, // Already formatted
//             "Last Updated": p.updatedAt,   // Already formatted
//             "Error Details": p.razorpay_error || 'N/A',
//             "Receipt URL": p.pdf_receipt_url || 'N/A'
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//         const csv = XLSX.utils.sheet_to_csv(worksheet);
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement('a');
//         link.href = URL.createObjectURL(blob);
//         link.setAttribute('download', 'admin_payment_records.csv');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const exportPDF = () => {
//         const doc = new jsPDF();
//         doc.text("Admin Payment Records", 14, 16);
//         doc.autoTable({
//             startY: 20,
//             head: [[
//                 "Order ID", "Proponent Name", "Project Type", "Sub Category",
//                 "Mobile", "Email", "Amount", "Status", "Initiated Date", "Updated Date"
//             ]], // Removed Payment ID from PDF header
//             body: payments.map(row => [
//                 row.razorpay_order_id,
//                 row.customer_name,
//                 row.project_type,
//                 row.sub_category,
//                 row.customer_phone,
//                 row.customer_email,
//                 `₹${row.amount}`,
//                 row.status?.toUpperCase(),
//                 row.timestamp, // Already formatted
//                 row.updatedAt // Already formatted
//             ]),
//             styles: { fontSize: 8 },
//             columnStyles: {
//                 // Adjust column widths if necessary for PDF
//                 0: { cellWidth: 20 },  // Order ID
//                 1: { cellWidth: 25 },  // Proponent Name
//                 2: { cellWidth: 18 },  // Project Type
//                 3: { cellWidth: 25 },  // Sub Category
//                 4: { cellWidth: 20 },  // Mobile
//                 5: { cellWidth: 25 },  // Email
//                 6: { cellWidth: 15 },  // Amount
//                 7: { cellWidth: 15 },  // Status
//                 8: { cellWidth: 25 },  // Initiated Date
//                 9: { cellWidth: 25 }   // Updated Date
//             },
//             didDrawPage: function (data) {
//                 // Footer
//                 let str = 'Page ' + doc.internal.getNumberOfPages();
//                 if (typeof doc.setFontSize === 'function') {
//                     doc.setFontSize(10);
//                 } else {
//                     doc.setProperties({
//                         fontSize: 10
//                     });
//                 }
//                 doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
//             }
//         });
//         doc.save('admin_payment_records.pdf');
//     };

//     const handleMenuClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleMenuClose = (format) => {
//         setAnchorEl(null);
//         if (format === 'csv') exportCSV();
//         if (format === 'excel') exportExcel();
//         if (format === 'pdf') exportPDF();
//     };

//     const handleLogout = () => {
//         navigate('/'); // Redirect to PaymentForm page (or login page)
//     };

//     return (
//         <Box className="admin-payment-container">
//             <Box className="admin-table-header" display="flex" justifyContent="space-between" alignItems="center">
//                 <Typography variant="h6" sx={{ fontWeight: 600 }}>Admin Payment Records</Typography>

//                 <Box display="flex" gap={2}>
//                     <Button
//                         variant="contained"
//                         startIcon={<DownloadIcon />}
//                         onClick={handleMenuClick}
//                         className="download-btn"
//                     >
//                         Download
//                     </Button>

//                     <Button
//                         variant="outlined"
//                         color="error"
//                         startIcon={<LogoutIcon />}
//                         onClick={handleLogout}
//                     >
//                         Logout
//                     </Button>
//                 </Box>

//                 <Menu
//                     anchorEl={anchorEl}
//                     open={Boolean(anchorEl)}
//                     onClose={() => setAnchorEl(null)}
//                 >
//                     <MenuItem onClick={() => handleMenuClose('csv')}>Download as CSV</MenuItem>
//                     <MenuItem onClick={() => handleMenuClose('excel')}>Download as Excel</MenuItem>
//                     <MenuItem onClick={() => handleMenuClose('pdf')}>Download as PDF</MenuItem>
//                 </Menu>
//             </Box>

//             <TextField
//                 fullWidth
//                 label="Search Payments (Name, Phone, Order ID, Status, Project Type, Sub Category, Amount)"
//                 variant="outlined"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                             <SearchIcon />
//                         </InputAdornment>
//                     ),
//                 }}
//                 sx={{ mb: 3 }}
//             />

//             {loading && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>}
//             {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

//             {!loading && !error && filteredPayments.length === 0 && (
//                 <Typography variant="h6" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
//                     No payments found matching your criteria.
//                 </Typography>
//             )}

//             {!loading && !error && filteredPayments.length > 0 && (
//                 <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3, borderRadius: '8px', overflow: 'hidden' }}>
//                     <Table className="admin-table">
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell className="table-cell-head">Order ID</TableCell>
//                                 {/* Removed Payment ID from table header */}
//                                 <TableCell className="table-cell-head">Proponent Name / Phone</TableCell>
//                                 <TableCell className="table-cell-head">Project Type</TableCell>
//                                 <TableCell className="table-cell-head">Sub Category</TableCell>
//                                 <TableCell className="table-cell-head">Email</TableCell>
//                                 <TableCell className="table-cell-head">Amount</TableCell>
//                                 <TableCell className="table-cell-head">Status</TableCell>
//                                 <TableCell className="table-cell-head">Initiated</TableCell>
//                                 <TableCell className="table-cell-head">Updated</TableCell>
//                                 <TableCell className="table-cell-head">Receipt</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {filteredPayments.map((row) => (
//                                 <TableRow key={row.id}>
//                                     <TableCell className="table-cell">{row.razorpay_order_id}</TableCell>
//                                     {/* Removed Payment ID from table body */}
//                                     <TableCell className="table-cell">
//                                         {row.customer_name}<br />{row.customer_phone}
//                                     </TableCell>
//                                     <TableCell className="table-cell">{row.project_type}</TableCell>
//                                     <TableCell className="table-cell">{row.sub_category}</TableCell>
//                                     <TableCell className="table-cell">{row.customer_email}</TableCell>
//                                     <TableCell className="table-cell">₹{row.amount}</TableCell>
//                                     <TableCell className="table-cell">
//                                         <Typography
//                                             variant="body2"
//                                             sx={{
//                                                 fontWeight: 'bold',
//                                                 color: row.status === 'completed' ? 'success.main' :
//                                                        row.status === 'failed' ? 'error.main' : 'warning.main'
//                                             }}
//                                         >
//                                             {row.status?.toUpperCase()}
//                                         </Typography>
//                                         {row.razorpay_error && (
//                                             <Typography variant="caption" color="text.secondary">
//                                                 ({row.razorpay_error})
//                                             </Typography>
//                                         )}
//                                     </TableCell>
//                                     {/* Display already formatted timestamps */}
//                                     <TableCell className="table-cell">{row.timestamp}</TableCell>
//                                     <TableCell className="table-cell">{row.updatedAt}</TableCell>
//                                     <TableCell className="table-cell">
//                                         {row.pdf_receipt_url && row.status === 'completed' ? (
//                                             <Button
//                                                 variant="contained"
//                                                 color="primary"
//                                                 size="small"
//                                                 href={row.pdf_receipt_url}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 startIcon={<DownloadIcon />}
//                                             >
//                                                 PDF
//                                             </Button>
//                                         ) : (
//                                             'N/A'
//                                         )}
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             )}
//         </Box>
//     );
// };

// export default AdminPaymentTable;






import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Box,
    Typography,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Menu,
    MenuItem,
    CircularProgress,
    Alert,
    TextField,
    InputAdornment,
    useMediaQuery,
    useTheme
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import LogoutIcon from '@mui/icons-material/Logout';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import './AdminPaymentTable.css';

const AdminPaymentTable = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const apiURL = process.env.REACT_APP_API_URL || 'https://your-api-endpoint.com';

    const formatFirestoreTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        if (typeof timestamp === 'object' && timestamp._seconds !== undefined) {
            return new Date(timestamp._seconds * 1000).toLocaleString();
        }
        return new Date(timestamp).toLocaleString();
    };

    useEffect(() => {
        const fetchAllPayments = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await axios.get(`${apiURL}/api/payments/all`);
                const formattedPayments = response.data.payments.map(payment => ({
                    ...payment,
                    timestamp: formatFirestoreTimestamp(payment.timestamp),
                    updatedAt: formatFirestoreTimestamp(payment.updatedAt)
                }));
                setPayments(formattedPayments);
            } catch (err) {
                console.error('Error fetching all payments:', err);
                setError('Failed to load payment records. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchAllPayments();
    }, [apiURL]);

    const filteredPayments = payments.filter(payment =>
        (payment.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.customer_phone?.includes(searchTerm) ||
        payment.razorpay_order_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (payment.razorpay_payment_id && payment.razorpay_payment_id.toLowerCase().includes(searchTerm.toLowerCase())) ||
        payment.status?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.project_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.sub_category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.amount?.toString().includes(searchTerm))
    );

    const exportExcel = () => {
        const dataToExport = filteredPayments.map(p => ({
            "Order ID": p.razorpay_order_id,
            "Payment ID": p.razorpay_payment_id || 'N/A',
            "Proponent Name": p.customer_name,
            "Project Type": p.project_type,
            "Sub Category": p.sub_category,
            "Mobile Number": p.customer_phone,
            "Email": p.customer_email,
            "Amount (INR)": p.amount,
            "Status": p.status,
            "Initiated Date": p.timestamp,
            "Last Updated": p.updatedAt,
            "Error Details": p.razorpay_error || 'N/A',
            "Receipt URL": p.pdf_receipt_url || 'N/A'
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
        XLSX.writeFile(workbook, "payment_records.xlsx");
    };

    const exportCSV = () => {
        const dataToExport = filteredPayments.map(p => ({
            "Order ID": p.razorpay_order_id,
            "Payment ID": p.razorpay_payment_id || 'N/A',
            "Proponent Name": p.customer_name,
            "Project Type": p.project_type,
            "Sub Category": p.sub_category,
            "Mobile Number": p.customer_phone,
            "Email": p.customer_email,
            "Amount (INR)": p.amount,
            "Status": p.status,
            "Initiated Date": p.timestamp,
            "Last Updated": p.updatedAt,
            "Error Details": p.razorpay_error || 'N/A',
            "Receipt URL": p.pdf_receipt_url || 'N/A'
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const csv = XLSX.utils.sheet_to_csv(worksheet);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'payment_records.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportPDF = () => {
        const doc = new jsPDF();
        doc.text("Payment Records", 14, 16);
        doc.autoTable({
            startY: 20,
            head: [[
                "Order ID", "Name", "Project", "Sub Category",
                "Mobile", "Amount", "Status", "Initiated"
            ]],
            body: filteredPayments.map(row => [
                row.razorpay_order_id,
                row.customer_name,
                row.project_type,
                row.sub_category,
                row.customer_phone,
                `₹${row.amount}`,
                row.status?.toUpperCase(),
                row.timestamp
            ]),
            styles: { fontSize: 8 },
            columnStyles: {
                0: { cellWidth: 25 },
                1: { cellWidth: 25 },
                2: { cellWidth: 20 },
                3: { cellWidth: 25 },
                4: { cellWidth: 20 },
                5: { cellWidth: 15 },
                6: { cellWidth: 15 },
                7: { cellWidth: 25 }
            }
        });
        doc.save('payment_records.pdf');
    };

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (format) => {
        setAnchorEl(null);
        if (format === 'csv') exportCSV();
        if (format === 'excel') exportExcel();
        if (format === 'pdf') exportPDF();
    };

    const handleLogout = () => {
        navigate('/');
    };

    return (
        <Box className="admin-payment-container">
            <Box className="admin-table-header">
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Payment Records
                </Typography>

                <Box display="flex" gap={2} sx={{ mt: isMobile ? 2 : 0 }}>
                    <Button
                        variant="contained"
                        startIcon={<DownloadIcon />}
                        onClick={handleMenuClick}
                        className="download-btn"
                        size={isMobile ? 'small' : 'medium'}
                    >
                        {isMobile ? 'Export' : 'Download'}
                    </Button>

                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        size={isMobile ? 'small' : 'medium'}
                    >
                        {isMobile ? 'Exit' : 'Logout'}
                    </Button>
                </Box>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem onClick={() => handleMenuClose('csv')}>CSV</MenuItem>
                    <MenuItem onClick={() => handleMenuClose('excel')}>Excel</MenuItem>
                    <MenuItem onClick={() => handleMenuClose('pdf')}>PDF</MenuItem>
                </Menu>
            </Box>

            <TextField
                fullWidth
                label={isMobile ? "Search..." : "Search by name, phone, order ID, etc."}
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                sx={{ mb: 3 }}
                size={isMobile ? 'small' : 'medium'}
            />

            {loading && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>}
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

            {!loading && !error && filteredPayments.length === 0 && (
                <Typography variant="h6" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
                    No matching records found
                </Typography>
            )}

            {!loading && !error && filteredPayments.length > 0 && (
                <TableContainer component={Paper} className="table-container">
                    <Table className="admin-table" sx={{ minWidth: isMobile ? '800px' : '100%' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Order ID</TableCell>
                                {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>Name/Phone</TableCell>}
                                {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>Project</TableCell>}
                                {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>Sub Category</TableCell>}
                                {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>}
                                <TableCell sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Initiated</TableCell>
                                {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>Updated</TableCell>}
                                <TableCell sx={{ fontWeight: 'bold' }}>Receipt</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredPayments.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell>{row.razorpay_order_id}</TableCell>
                                    
                                    {isMobile ? (
                                        <TableCell colSpan={5}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                <div><strong>Name:</strong> {row.customer_name}</div>
                                                <div><strong>Phone:</strong> {row.customer_phone}</div>
                                                <div><strong>Project:</strong> {row.project_type}</div>
                                                <div><strong>Sub Cat:</strong> {row.sub_category}</div>
                                                <div><strong>Email:</strong> {row.customer_email}</div>
                                            </Box>
                                        </TableCell>
                                    ) : (
                                        <>
                                            <TableCell>
                                                {row.customer_name}<br/>{row.customer_phone}
                                            </TableCell>
                                            <TableCell>{row.project_type}</TableCell>
                                            <TableCell>{row.sub_category}</TableCell>
                                            <TableCell>{row.customer_email}</TableCell>
                                        </>
                                    )}
                                    
                                    <TableCell>₹{row.amount}</TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 'bold',
                                                color: row.status === 'completed' ? 'success.main' :
                                                       row.status === 'failed' ? 'error.main' : 'warning.main',
                                                fontSize: isMobile ? '0.75rem' : '0.875rem'
                                            }}
                                        >
                                            {row.status?.toUpperCase()}
                                        </Typography>
                                        {row.razorpay_error && (
                                            <Typography variant="caption" color="text.secondary">
                                                {row.razorpay_error}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell>{row.timestamp}</TableCell>
                                    {!isMobile && <TableCell>{row.updatedAt}</TableCell>}
                                    <TableCell>
                                        {row.pdf_receipt_url && row.status === 'completed' ? (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                href={row.pdf_receipt_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{ 
                                                    p: isMobile ? '4px' : '6px 8px',
                                                    minWidth: 'auto'
                                                }}
                                            >
                                                {isMobile ? <DownloadIcon fontSize="small" /> : 'PDF'}
                                            </Button>
                                        ) : 'N/A'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default AdminPaymentTable;